export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";